import { attendanceStructureService } from "../services/api";
import { POLICIES_STORAGE_KEY, SHIFTS_STORAGE_KEY } from "./attendancePolicyEngine";
import { ATTENDANCE_POLICY_UPDATED_EVENT } from "./attendanceDemoSeed";

/**
 * Mirror company attendance shifts from the API into localStorage so ESS
 * Change Shift dropdowns (and punch eval) use the same catalog as admin.
 * Does not overwrite a non-empty local catalog when the API returns empty.
 */
export async function syncAttendanceShiftsCache() {
  try {
    const res = await attendanceStructureService.getAttendanceShifts();
    const apiList = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
    if (apiList.length && typeof localStorage !== "undefined") {
      localStorage.setItem(SHIFTS_STORAGE_KEY, JSON.stringify(apiList));
      window.dispatchEvent(new Event(ATTENDANCE_POLICY_UPDATED_EVENT));
    }
    return apiList;
  } catch {
    return [];
  }
}

/**
 * Mirror company attendance policies from the API into localStorage so ESS
 * Check In / status evaluation uses the same policy as admin (not an empty
 * browser cache on the live employee login).
 */
export async function syncAttendancePoliciesCache() {
  let apiList = [];
  try {
    const res = await attendanceStructureService.getAttendancePolicies();
    apiList = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
    if (apiList.length && typeof localStorage !== "undefined") {
      localStorage.setItem(POLICIES_STORAGE_KEY, JSON.stringify(apiList));
      window.dispatchEvent(new Event(ATTENDANCE_POLICY_UPDATED_EVENT));
    }
  } catch {
    apiList = [];
  }
  await syncAttendanceShiftsCache();
  return apiList;
}
